/**
 * Full-screen "on-air loading" splash matching the pre-React HTML splash in index.html.
 * Used by the /broadcast route while weather + slide config are still loading so the
 * loop never falls back to black before content is ready.
 */
export default function SplashScreen({ label = "On‑Air Loading" }) {
  return (
    <div
      data-testid="broadcast-splash"
      className="fixed inset-0 z-40 flex flex-col items-center justify-center gap-7 bg-black"
      style={{
        background:
          "radial-gradient(1000px 500px at 50% 30%, #12223d 0%, #0a1222 55%, #050a14 100%)",
      }}
    >
      <img
        src="/gwn-logo.png"
        alt="Georgia Weather Network"
        className="w-[min(58vw,380px)] drop-shadow-[0_12px_40px_rgba(31,99,201,0.5)] gawx-splash-pulse"
      />
      <div className="inline-flex items-center gap-2.5">
        <span className="live-dot" />
        <span className="font-oswald text-xs font-bold uppercase tracking-[0.4em] text-[#ffd60a]">
          {label}
        </span>
      </div>
      <div className="h-0.5 w-36 overflow-hidden bg-white/10">
        <span className="block h-full w-2/5 gawx-splash-bar bg-gradient-to-r from-transparent via-[#1f63c9] to-transparent" />
      </div>
    </div>
  );
}
